import { ComponentPropsWithoutRef, forwardRef } from 'react'

import { cn } from '../utils'
import { Button } from './button'
import { Icon } from './icon'

export const Expand = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<'button'> & { label?: string; size?: 'sm' }
>(({ label, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      {...props}
      variant="ghost"
      className={cn(
        'group inline-flex cursor-pointer items-center gap-2 rounded-md p-1 transition-transform active:scale-95',
        props.className,
      )}
      onClick={props.onClick}
    >
      {!!label && <span>{label}</span>}
      <Icon name="arrows-out-simple" className="h-4" />
    </Button>
  )
})
